import { render } from "./AdminPagesServices.vue?vue&type=template&id=7924b118"
import script from "./AdminPagesServices.vue?vue&type=script&lang=js"
export * from "./AdminPagesServices.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__